import React from 'react';

import { ReactFCV } from '@types';

import { StyledBlock, StyledRow } from '../../styled';

/**
 * AddressSkeletonBlock Component.
 *
 * This component represents a single block of an address skeleton. It is used to
 * display a placeholder block with multiple rows to simulate the structure of an address.
 */
export const AddressSkeletonBlock: ReactFCV = () => (
  <StyledBlock>
    <StyledRow />
    <StyledRow />
    <StyledRow />
    <StyledRow />
  </StyledBlock>
);
